module.exports = __webpack_public_path__ + "381a9ca747309b2698276e6b41f63f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/logo-light.png
// module id = 1526
// module chunks = 0